import { css } from '@emotion/react';

import { colors } from '../../styles/colors';
import { MediaBP as MQ } from '../../styles/mediaQuery';
export const playerWidgetSkeletonWrapper = css`
  width: 100%;
  height: 48px;
  position: absolute;
  background-color: ${colors.TemplateLoaderAccent};
  ${MQ.MediaLg} {
    position: relative;
    height: 65px;
    width: 100%;
  }
`;
